import classes from "./CheckIcon.module.css";

const CheckIcon = (props) => {
  return <span className={classes["check-icon"]}></span>;
};

export default CheckIcon;
